import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import classNames from "classnames/bind";

import UIIcon from "../UIIcon";
import styles from "./InfoButton.module.scss";

const cx = classNames.bind(styles);

export type InfoButtonProps = DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
>;

const InfoButton = (props: InfoButtonProps) => {
    return (
        <button className={cx("infoButton")} type="button" {...props}>
            <UIIcon icon="Info" />
        </button>
    );
};

export default InfoButton;
